import styled from 'styled-components'

interface ActivityAreaProps {
  area: string
}
export const ActivityArea = styled.div<ActivityAreaProps>`
  grid-area: ${props => props.area};
`
